import { useQuery } from '@tanstack/react-query';

import getScheduleHostList from 'Api/schedule/getScheduleHostList';

import getScheduleHostListRequest from './model/request/getScheduleHostListRequest';
import getScheduleHostListResponse from './model/response/getScheduleHostListResponse';

const useGetScheduleHostList = ({ payload = {} }) => {
  return useQuery({
    queryKey: ['schedules-hosts', payload],
    queryFn: async () => {
      const queries = getScheduleHostListRequest(payload);

      let response = await getScheduleHostList({ queries });

      const result = getScheduleHostListResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: 0,
    gcTime: 0,
    enabled: Boolean(payload?.startedAt && payload?.endedAt),
  });
};

export default useGetScheduleHostList;
